export enum ReservationMode {
  DAILY = 'daily',
  MONTHLY = 'monthly'
}
